import { HttpInterceptorFn } from '@angular/common/http'

enum HeaderKeys {
	HeaderName = 'Content-Type',
	ContentType = 'application/json',
}

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
	const headers = req.headers.set(HeaderKeys.HeaderName, HeaderKeys.ContentType)

	return next(req.clone({ headers }))
}
